import SafeMath from 'common/safeMath';

export default class AmountConvert {
    static annualStandardWorkHours: number = 2080;

    static homeCurrencyExchangeRateRatio: number = 1;

    static defaultClampedFractionDigits: number = 4;

    static convertCurrencyValue(
        value: number,
        sourceExchangeRateRatio: number,
        targetExhangeRateRatio: number
    ): number {
        return SafeMath.divide(value, targetExhangeRateRatio) * sourceExchangeRateRatio;
    }

    static convertToHomeCurrencyValue(
        value: number,
        sourceExchangeRateRatio: number
    ): number {
        return AmountConvert
            .convertCurrencyValue(value, sourceExchangeRateRatio, AmountConvert.homeCurrencyExchangeRateRatio);
    }

    static convertFromHomeCurrencyValue(value: number, targetExhangeRateRatio: number): number {
        return AmountConvert
            .convertCurrencyValue(value, AmountConvert.homeCurrencyExchangeRateRatio, targetExhangeRateRatio);
    }

    static convertToAnnual(
        amount: number,
        annualStandardWorkHours: number,
        isHourly: boolean,
        fullTimeEquivalent: number = 1
    ): number {
        if (isHourly) {
            return amount * annualStandardWorkHours * fullTimeEquivalent;
        }

        return amount;
    }

    static convertToHourly(annualAmount: number, annualStandardWorkHours: number): number {
        return SafeMath.divide(annualAmount, annualStandardWorkHours);
    }

    static clampValue(value: number): number {
        const decimalPlaces = Math.pow(10, AmountConvert.defaultClampedFractionDigits);
        let roundedValue = value * decimalPlaces;
        roundedValue = Math.floor(roundedValue);
        return roundedValue / decimalPlaces;
    }
}